import React, { type FC, memo, use, useMemo } from "react";
import { AppRoutes } from "@domain/routing/routeConstants";
import { useLocation } from "react-router-dom";
import { PdfToolsPaths } from "@pdf-tools/types";
import { UserContext } from "@domain/context/UserProvider";
import { ModuleNav, type NavItem } from "./ModuleNav";

const ModulePDFLinksImpl: FC = () => {
    const { pathname = "" } = useLocation();
    const { isAdmin } = use(UserContext);
    const link = AppRoutes.ocr + "/" + PdfToolsPaths.Stats;
    const selectedKeys = useMemo(() => [pathname], [pathname]);
    // OCR statistics is an admin-only view; hide the nav link for everyone else.
    const items = useMemo<NavItem[]>(() => (isAdmin ? [{ key: link, to: link, label: "Stats" }] : []), [link, isAdmin]);
    return <ModuleNav selectedKeys={selectedKeys} items={items} />;
};

export const ModulePDFLinks = memo(ModulePDFLinksImpl);
